module.exports = __webpack_public_path__ + "static/img/day1.196c2ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/day1.jpg
// module id = AktK
// module chunks = 0